import { render } from "./EmailConfirmation.vue?vue&type=template&id=a28f6af6&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=ts"
export * from "./EmailConfirmation.vue?vue&type=script&lang=ts"

import "./EmailConfirmation.vue?vue&type=style&index=0&id=a28f6af6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a28f6af6"

export default script